import { TEmailTemplatesForm } from "../codecs/form/EmailTemplatesForm";
import { emailTemplateLibrary, TEmailTemplateDefinition } from "./templateLibrary";

// Falls back to the code library whenever the table has no templates to offer, which covers
// both the request still being in flight and an environment where the seed has never run -
// demoData and the integration-test truncation both empty the table.
//
// The fallback cannot serve stale copy: it is unreachable the moment a single template
// exists to edit, so a handler can never be shown the original wording of a template
// somebody has since rewritten.
export const templatesForPicker = (form: TEmailTemplatesForm): Array<TEmailTemplateDefinition> => {
    const fromDatabase = form.children.email_template_forms.map(({ edited }) => edited);
    return fromDatabase.length > 0 ? fromDatabase : emailTemplateLibrary;
};
